import React from "react";
import { Button, Checkbox, Popover, Radio, Divider, Menu, Dropdown } from "antd";
import { getCategoriesList, getFeaturesList } from "../../../../../../utils/constants"
import Arrow from "../../../../../../assets/images/Inner/arrow.svg";
import CloseCheck from "../../../../../../assets/images/close.png";
import {firstYear, lastYear, secondYear} from "../../../../../../utils/constants";
import _, { first } from "lodash";


const FilterPills = (props) => {

  // 
  const {
    
    // filters
    selectedCategories,
    selectedFeatures,
    onFilterChange,
    setFilterSelectedCategories,
    setFilterSelectedFeatures,

    // intro bonus toggle
    isIncludeIntroBonus,
    onIncludeIntroChange,
    
    // projection years
    yearProjection, 
    onYearProjectionChange,

    // defaults
    defaultIsIntroBonus = false,
    defaultYearProjection = firstYear(),
    defaultSelectedCategories = [],
    defaultSelectedFeatures = [],
    
  } = props || {};
  
  // projection years
  const projYears = [firstYear, secondYear, lastYear]; // note that these are fns for some reason
  
  // these are grouped to multiselect pills
  const multiselectCredit = [
    "Good to Excellent Credit",
    "Fair Credit",
    "Low & No Credit",
  ];
  const multiselectCashback = [
    "Flat Rate Cash Back",
    "Rotating Categories",
    "Category Cash Back",
  ]
  
  // add classes for ga
  React.useEffect(() => {
    setTimeout(() => {
      
      // cat
      for (let category of getCategoriesList()) {
        const cn = "ga-facet-filter-cat-" + category.replaceAll(" ","_");
        const elements = document.getElementsByClassName(cn);
        for (let element of elements) {
          const children = element.children;
          for (let child of children) {
            child.classList.add(cn);
          }
        }
      }
      
      // features
      for (let feature of getFeaturesList()) {
        const cn = "ga-facet-filter-feat-" + feature.replaceAll(" ","_");
        const elements = document.getElementsByClassName(cn);
        for (let element of elements) {
          const children = element.children;
          for (let child of children) {
            child.classList.add(cn);
          }
        }
      }
      
      // proj years
      for (let yr of projYears) {
        const cn = `ga-facet-filter-projyear${yr()}`;
        const elements = document.getElementsByClassName(cn);
        for (let element of elements) {
          const children = element.children;
          for (let child of children) {
            child.classList.add(cn);
          }
        }
      }
      
    }, 100); // delay ensures rendering complete
  }, []);


  // does it need reset?
  const is_at_reset = 
    yearProjection == defaultYearProjection && 
    (isIncludeIntroBonus == defaultIsIntroBonus) && 
    _.isEqual([...selectedCategories].sort(), [...defaultSelectedCategories].sort()) && 
    _.isEqual([...selectedFeatures].sort(), [...defaultSelectedFeatures].sort())
  ;
  
  // 
  return (
    <div>

      {/* labels */}
      <div className="filter-pills-label">
        <div className="filter-pills-reset-button" onClick={() => { // reset
          onIncludeIntroChange(defaultIsIntroBonus);
          onYearProjectionChange(defaultYearProjection);
          setFilterSelectedCategories(defaultSelectedCategories);
          setFilterSelectedFeatures(defaultSelectedFeatures);
        }}>
          {is_at_reset? "" : "RESET FILTERS"}
        </div>
      </div>

      {/* main container */}
      <div className="filter-pills-container">

        
        {/* intro bonus */}
        <Dropdown 
          overlay={(
            <Menu onClick={(e) => {
              onIncludeIntroChange(e.key === "true");
            }}>
              <Menu.Item key="true" className="ga-facet-filter-introbonus">Include Intro Bonus</Menu.Item>
              <Menu.Item key="false" className="ga-facet-filter-introbonus">Exclude Intro Bonus</Menu.Item>
            </Menu>
          )} 
          trigger={["click"]}
        >
          <Button
            type="default"
            className={"active-pill"}
            onFocus={e => e.target.blur()}
            key={"isIncludeIntroBonus"}
          >
            {isIncludeIntroBonus? "Include Intro Bonus" : "Exclude Intro Bonus"} &#9662;
          </Button>
        </Dropdown>
        
        {/* proj year */}
        <Dropdown 
          overlay={(
            <Menu onClick={(e) => onYearProjectionChange(e.key)}>
              { _.map(projYears, yr => 
                <Menu.Item key={yr()} className={`ga-facet-filter-projyear${yr()}`}>
                  {yr()}-Year Projection
                </Menu.Item>
              )}
            </Menu>
          )} 
          trigger={["click"]}
        >
          <Button
            type="default"
            className={"active-pill"}
            onFocus={e => e.target.blur()}
            key={yearProjection + "yr"}
          >
            {yearProjection}-Year Projection &#9662;
          </Button>
        </Dropdown>
        
        {/* cat (skip cash back) */}
        {_.map(_.filter(getCategoriesList(), el => el != "Cash Back") || [], (category, index) => (
          _.includes(multiselectCredit, category)? null : 
          <Button
            type="default"
            className={
              "ga-facet-filter-cat-" + category.replaceAll(" ","_") + 
              ((selectedCategories || []).includes(category)? " active-pill" : "")
            }
            onClick={() => onFilterChange("selectedCategories", category)}
            onFocus={e => e.target.blur()}
            key={category}
          >
            {category}
          </Button>
        ))}
        
        {/* cat - multiselect */}
        <Dropdown 
          overlay={(
            <Menu onClick={(e) => onFilterChange("selectedCategories", e.key)} selectedKeys={selectedCategories}>
              {_.map(multiselectCredit, cat => 
                <Menu.Item key={cat} className={"ga-facet-filter-cat-" + cat.replaceAll(" ", "_")}>
                  {cat}
                </Menu.Item>
              )}
            </Menu>
          )} 
          trigger={["click"]}
        >
          <Button
            type="default"
            className={_.intersection(multiselectCredit, selectedCategories).length? "active-pill" : ""}
            onFocus={e => e.target.blur()}
            key={"creditscore"}
          >
            {_.intersection(multiselectCredit, selectedCategories).length?
              <div className="pill-badge">
                {_.intersection(multiselectCredit, selectedCategories).length}
              </div>
              : null
            }
            Credit Score &#9662;
          </Button>
        </Dropdown>
        
        
        {/* feat */}
        {_.map(getFeaturesList() || [], (feature, index) => (
          _.includes(multiselectCashback, feature)? null : 
          <Button
            type="default"
            className={
              "ga-facet-filter-feat-" + feature.replaceAll(" ","_") + 
              ((selectedFeatures || []).includes(feature)? " active-pill" : "")
            }
            onClick={() => onFilterChange("selectedFeatures", feature)}
            onFocus={e => e.target.blur()}
            key={feature}
          >
            {feature}
          </Button>
        ))}
        
        {/* feat - multiselect */}
        <Dropdown 
          overlay={(
            <Menu onClick={(e) => onFilterChange("selectedFeatures", e.key)} selectedKeys={selectedFeatures}>
              {_.map(multiselectCashback, feat => 
                <Menu.Item key={feat} className={"ga-facet-filter-feat-" + feat.replaceAll(" ", "_")}>
                  {feat}
                </Menu.Item>
              )}
            </Menu>
          )} 
          trigger={["click"]}
        >
          <Button
            type="default"
            className={_.intersection(multiselectCashback, selectedFeatures).length? "active-pill" : ""}
            onFocus={e => e.target.blur()}
            key={"cashback"}
          >
            {_.intersection(multiselectCashback, selectedFeatures).length?
              <div className="pill-badge">
                {_.intersection(multiselectCashback, selectedFeatures).length}
              </div>
              : null
            }
            Cash Back &#9662;
          </Button>
        </Dropdown>
        
        
      </div>
    </div>
  );
  
}

export default FilterPills
